import React, { Component } from "react";
import PropTypes from "prop-types";
import { Editor, EditorState } from "draft-js";
import { withStyles } from "material-ui/styles";
import { postToContentState, contentStateToPost } from "./postConversion";
import "./PostEditor.css";

const styleSheet = theme => ({
    editorStyle: Object.assign(
        {
            padding: 0
        },
        theme.typography.body1,
        {
            lineHeight: "1.6rem"
        }
    )
});

class PostEditor extends Component {
    state = {
        editorState: null
    };

    constructor(props) {
        super(props);
        this.state = { editorState: PostEditor.initEditorState(props.text) };
    }

    static initEditorState(text) {
        if (text) {
            return EditorState.createWithContent(
                postToContentState(text || "")
            );
        }
        return EditorState.createEmpty();
    }

    onChange = editorState => {
        this.props.onChange(
            contentStateToPost(editorState.getCurrentContent())
        );
        this.setState({ editorState });
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.readOnly && nextProps.text !== this.props.text) {
            this.setState({
                editorState: PostEditor.initEditorState(nextProps.text)
            });
        }
    }

    focus() {
        if (this.editor) {
            this.editor.focus();
        }
    }

    onClick = () => {
        this.focus();
    };

    render() {
        const { placeholder, classes, readOnly } = this.props;
        const { editorState } = this.state;
        return (
            <div
                onClick={this.onClick}
                className={classes.editorStyle + " postEditor"}>
                <Editor
                    ref={r => {
                        this.editor = r;
                        this.props.rootRef(r);
                    }}
                    readOnly={readOnly}
                    customStyleMap={{
                        BOLD: {}
                    }}
                    placeholder={placeholder}
                    editorState={editorState}
                    onChange={this.onChange}
                />
            </div>
        );
    }
}

PostEditor.propTypes = {
    placeholder: PropTypes.string,
    text: PropTypes.string,
    readOnly: PropTypes.bool,
    onChange: PropTypes.func,
    rootRef: PropTypes.func,
    classes: PropTypes.object
};

PostEditor.defaultProps = {
    placeholder: "",
    readOnly: false,
    text: "",
    onChange: () => {},
    rootRef: () => {}
};

export default withStyles(styleSheet)(PostEditor);



// WEBPACK FOOTER //
// ./src/components/PostEditor.jsx